import { formatearFechaHora, NOMBRE_ETAPA } from "@gestiondoc/shared";
import type { RevisionDetalle } from "../tipos.ts";
import { trazoComoImagen } from "../utiles.ts";
import { sinRevisor } from "./firmas.ts";
import { Pildora } from "./ui.tsx";

/**
 * Una columna por etapa de la ruta de una revisión (Elaboró · Revisó · Aprobó, o dos en la ruta
 * corta), con la de la persona que mira resaltada y la imagen de cada firma ya dada.
 */
export function FlujoDeFirmas({ revision, yo }: { revision: RevisionDetalle; yo: string }) {
  const pasos = sinRevisor(revision)
    ? revision.ruta.filter((p) => p.etapa !== "reviso")
    : revision.ruta;
  return (
    <div className={`mb-5 grid gap-3 ${pasos.length === 2 ? "md:grid-cols-2" : "md:grid-cols-3"}`}>
      {pasos.map((p) => {
        const mia = p.usuario?.id === yo && p.leToca;
        return (
          <div
            key={p.etapa}
            className={`rounded-tarjeta border p-4 ${
              mia ? "border-marino bg-marino-claro" : "border-borde bg-white"
            }`}
          >
            <div className="mb-2 flex items-center justify-between">
              <div className="text-[13px] font-bold text-marino">{NOMBRE_ETAPA[p.etapa]}</div>
              {p.firma ? (
                <Pildora tono="bg-verde-fondo text-verde">Firmado</Pildora>
              ) : (
                <Pildora tono={p.leToca ? "bg-ambar-fondo text-ambar" : "bg-gris-fondo text-gris"}>
                  Pendiente
                </Pildora>
              )}
            </div>
            <div className="text-[13px] font-semibold">{p.usuario?.nombre ?? "Sin asignar"}</div>
            <div className="text-[11.5px] text-texto-3">
              {p.firma
                ? `${p.firma.usuario.puesto} · ${formatearFechaHora(p.firma.firmadoEn)}`
                : mia
                  ? "te corresponde a ti"
                  : (p.usuario?.puesto ?? "")}
            </div>
            {p.firma ? (
              <div className="mt-3">
                <img
                  src={
                    p.firma.imagenId
                      ? `/archivos/${p.firma.imagenId}`
                      : trazoComoImagen(p.firma.trazoSvg ?? "")
                  }
                  alt={`Firma de ${p.firma.usuario.nombre}`}
                  className="h-[60px] w-full rounded border border-borde bg-white object-contain"
                />
                <div className="mt-1.5 font-mono text-[11px] text-texto-3">
                  ID de firma <span className="font-semibold text-marino">{p.firma.idFirma}</span>
                  {/* La IP solo le llega a Soporte Tecnológico. */}
                  {p.firma.ip && ` · IP ${p.firma.ip}`}
                </div>
              </div>
            ) : (
              <div className="mt-3 grid h-[60px] place-items-center rounded border border-dashed border-borde text-[11.5px] text-texto-3">
                Sin firma todavía
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
